import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('common', ['vipInfo', 'vipRight'])
  },
  methods: {
    async compareRight(options) {
      await this.getVipInfo()
      return this.compare(options)
    },
    // 更新vip及vip权益信息
    async getVipInfo() {
      const isVip = await this.$store.dispatch('common/getVipInfo')
      // 免费版为非会员，type传free
      await this.$store.dispatch('common/getVipRight', isVip ? this.vipInfo.authProductType : 'free')
    },
    compare(options) {
      if (options.type === 'num') {
        if (options.key === 'childAccountNum') {
          // 子账号数量 999 代表无限制
          if (this.vipRight[options.key] === 999) {
            return true
          }
        }
        return options.value < this.vipRight[options.key]
      } else if (options.type === 'boole') {
        return this.vipRight[options.key]
      }
    }
  }
}
